function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { isError, truncate } from '@sentry/utils';
import { defineIntegration } from '../integration.js';
var DEFAULT_LIMIT = 10;
var INTEGRATION_NAME = 'ZodErrors'; // Simplified ZodIssue type definition

function originalExceptionIsZodError(originalException) {
  return isError(originalException) && originalException.name === 'ZodError' && Array.isArray(originalException.errors);
}
/**
 * Formats child objects or arrays to a string
 * That is preserved when sent to Sentry
 */


function formatIssueTitle(issue) {
  return _objectSpread(_objectSpread({}, issue), {}, {
    path: 'path' in issue && Array.isArray(issue.path) ? issue.path.join('.') : undefined,
    keys: 'keys' in issue ? JSON.stringify(issue.keys) : undefined,
    unionErrors: 'unionErrors' in issue ? JSON.stringify(issue.unionErrors) : undefined
  });
}
/**
 * Zod error message is a stringified version of ZodError.issues
 * This doesn't display well in the Sentry UI. Replace it with something shorter.
 */


function formatIssueMessage(zodError) {
  var errorKeyMap = new Set();

  var _iterator = _createForOfIteratorHelper(zodError.issues),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var iss = _step.value;

      if (iss.path && iss.path[0]) {
        errorKeyMap.add(iss.path[0]);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  var errorKeys = Array.from(errorKeyMap);
  return "Failed to validate keys: ".concat(truncate(errorKeys.join(', '), 100));
}
/**
 * Applies ZodError issues to an event extras and replaces the error message
 */


function applyZodErrorsToEvent(limit, event, hint) {
  if (!event.exception || !event.exception.values || !hint || !hint.originalException || !originalExceptionIsZodError(hint.originalException) || hint.originalException.issues.length === 0) {
    return event;
  }

  return _objectSpread(_objectSpread({}, event), {}, {
    exception: _objectSpread(_objectSpread({}, event.exception), {}, {
      values: [_objectSpread(_objectSpread({}, event.exception.values[0]), {}, {
        value: formatIssueMessage(hint.originalException)
      })].concat(_toConsumableArray(event.exception.values.slice(1)))
    }),
    extra: _objectSpread(_objectSpread({}, event.extra), {}, {
      'zoderror.issues': hint.originalException.errors.slice(0, limit).map(formatIssueTitle)
    })
  });
}

var _zodErrorsIntegration = function _zodErrorsIntegration() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var limit = options.limit || DEFAULT_LIMIT;
  return {
    name: INTEGRATION_NAME,
    processEvent: function processEvent(originalEvent, hint) {
      var processedEvent = applyZodErrorsToEvent(limit, originalEvent, hint);
      return processedEvent;
    }
  };
};

var zodErrorsIntegration = defineIntegration(_zodErrorsIntegration);
export { applyZodErrorsToEvent, zodErrorsIntegration };